"use client"

import { useState, useEffect } from "react"
import { AnimatePresence } from "framer-motion"
import { Edit2, Trash2, Plus } from "lucide-react"
import {
  TableContainer,
  TableHeader,
  TableTitle,
  AddButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ResponsiveTableWrapper,
} from "./styled/Table"
import { InventoryModal } from "../InventoryModal"


export const InventoryTable = ({
  inventory,
  products,
  onAddInventory,
  onEditInventory,
  onDeleteInventory,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingItem, setEditingItem] = useState(null)

  const tableVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  }

  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
    hover: { scale: 1.01 },
  }

  const handleOpenModal = (item) => {
    setEditingItem(item || null)
    console.log(item)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setEditingItem(null)
    setIsModalOpen(false)
  }

  const handleSaveInventory = async (item) => {
    if (editingItem) {
      onEditInventory(item)

    } else {
      onAddInventory(item)

    }
    handleCloseModal()
  }

  const handleDelete = (itemId) => {
    if (window.confirm("¿Estás seguro de que quieres eliminar este inventario?")) {
      onDeleteInventory(itemId)
    }
  }

  return (
    <TableContainer initial="hidden" animate="visible" variants={tableVariants}>
      <TableHeader>
        <TableTitle>Inventario</TableTitle>
        <AddButton whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => handleOpenModal()}>
          <Plus size={16} />
          Añadir Inventario
        </AddButton>
      </TableHeader>
      <ResponsiveTableWrapper>
        <Table>
          <TableHead>
            <tr>
              <TableCell as="th">PRODUCTO</TableCell>
              <TableCell as="th">COLOR</TableCell>
              <TableCell as="th">TALLA</TableCell>
              <TableCell as="th">STOCK</TableCell>
              <TableCell as="th">ESTADO</TableCell>
              <TableCell as="th">ACCIONES</TableCell>
            </tr>
          </TableHead>
          <TableBody>
            <AnimatePresence>
              {inventory?.map((item) => (
                <TableRow key={item.id} variants={rowVariants} whileHover="hover" layout>
                  <TableCell data-label="Producto">{products.find(pr => pr.id == item.productid)?.nombre}</TableCell>
                  <TableCell data-label="Color">
                    <div
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: item.color,
                        border: "2px solid rgba(255,255,255,0.1)",
                      }}
                    />
                  </TableCell>
                  <TableCell data-label="Talla">{item.talla}</TableCell>
                  <TableCell data-label="Stock">{item.quantity}</TableCell>
                  <TableCell data-label="Estado">
                    <span style={{ color: item.status == 1 ? "#4CAF50" : "#FF4444" }}>
                      {item.status == 1 ? "Activo" : "Inactivo"}
                    </span>
                  </TableCell>
                  <TableCell data-label="Acciones">
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={() => handleOpenModal(item)}
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                      >
                        <Edit2 size={18} color="#4A88F3" />
                      </button>
                      <button
                        onClick={() => handleDelete(item.id)}
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                      >
                        <Trash2 size={18} color="#FF4444" />
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </AnimatePresence>
          </TableBody>
        </Table>
      </ResponsiveTableWrapper>
      <InventoryModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveInventory}
        item={editingItem}
        products={products}
      />
    </TableContainer>
  )
}

